import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import KeepAliveView from '../components/KeepAliveView.vue'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') return Promise.reject(err)
  })
}
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') return Promise.reject(err)
  })
}

// 静态路由（不需要权限的路由）
const staticRoutes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/403',
    name: '403',
    component: () => import('../views/403.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/404',
    name: '404',
    component: () => import('../views/404.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/mobile/inspection',
    name: 'MobileInspection',
    component: () => import('../views/mobile/MobileInspection.vue'),
    meta: { requiresAuth: false, standalone: true }
  }
]

// 动态路由（需要权限的路由）
const dynamicRoutes = [
  // 首页（一级菜单）
  {
    path: '/home',
    name: 'Home',
    component: () => import('../views/monitoring-center/IntegratedMonitoring.vue'),
    meta: {
      title: '首页',
      icon: 'el-icon-s-home',
      permission: 'home:view',
      requiresAuth: true
    }
  },
  
  // 监控中心
  {
    path: '/monitoring-center',
    name: 'MonitoringCenter',
    component: KeepAliveView,
    meta: {
      title: '监控中心',
      icon: 'el-icon-s-home',
      permission: 'monitoring-center:view',
      requiresAuth: true
    },
    children: [
      {
        path: 'site-monitoring',
        name: 'SiteMonitoring',
        component: () => import('../views/monitoring-center/SiteMonitoring.vue'),
        meta: {
          title: '站点监控',
          icon: 'el-icon-s-grid',
          permission: 'monitoring-center:site-monitoring:view'
        }
      },
      {
        path: 'flow-monitoring',
        name: 'FlowMonitoring',
        component: () => import('../views/monitoring-center/FlowMonitoring.vue'),
        meta: {
          title: '流量监控',
          icon: 'el-icon-s-marketing',
          permission: 'monitoring-center:flow-monitoring:view'
        }
      },
      {
        path: 'power-monitoring',
        name: 'PowerMonitoring',
        component: () => import('../views/monitoring-center/PowerMonitoring.vue'),
        meta: {
          title: '电量监控',
          icon: 'el-icon-lightning',
          permission: 'monitoring-center:power-monitoring:view'
        }
      },
      {
        path: 'rainfall-monitoring',
        name: 'RainfallMonitoring',
        component: () => import('../views/monitoring-center/RainfallMonitoring.vue'),
        meta: {
          title: '雨量监控',
          icon: 'el-icon-connection',
          permission: 'monitoring-center:rainfall-monitoring:view'
        }
      },
      {
        path: 'station-detail',
        name: 'StationDetail',
        component: () => import('../views/monitoring-center/StationDetail.vue'),
        meta: {
          title: '站点详情',
          icon: 'el-icon-s-mark',
          permission: 'monitoring-center:station-detail:view',
          hidden: true
        }
      },
      {
        path: 'route-planning/:id',
        name: 'RoutePlanning',
        component: () => import('../views/monitoring-center/RoutePlanning.vue'),
        meta: {
          title: '路线规划',
          icon: 'el-icon-s-mark',
          permission: 'monitoring-center:route-planning:view',
          hidden: true
        }
      },
      {
          path: 'hydraulic-model',
          name: 'HydraulicModel',
          component: () => import('../views/monitoring-center/HydraulicModel.vue'),
          meta: {
            title: '水力模型',
            icon: 'el-icon-s-mark',
            permission: 'monitoring-center:hydraulic-model:view',
            hidden: true
          }
        },
      {
        path: 'vehicle-monitoring',
        name: 'VehicleMonitoring',
        component: () => import('../views/monitoring-center/VehicleMonitoring.vue'),
        meta: {
          title: '车辆监控',
          icon: 'el-icon-truck',
          permission: 'monitoring-center:vehicle-monitoring:view'
        }
      },
      {
        path: 'chemical-monitoring',
        name: 'ChemicalMonitoring',
        component: () => import('../views/monitoring-center/ChemicalMonitoring.vue'),
        meta: {
          title: '药剂监控',
          icon: 'el-icon-s-order',
          permission: 'monitoring-center:chemical-monitoring:view',
          hidden: true
        }
      }
    ]
  },
  
  // 运维中心
  {
    path: '/operation-center',
    name: 'OperationCenter',
    component: KeepAliveView,
    meta: {
      title: '运维中心',
      icon: 'el-icon-s-operation',
      permission: 'operation-center:view',
      requiresAuth: true
    },
    children: [
      {
        path: 'daily-inspection',
        name: 'DailyInspection',
        component: () => import('../views/operation-center/DailyInspection.vue'),
        meta: {
          title: '日常巡检',
          icon: 'el-icon-s-order',
          permission: 'operation-center:daily-inspection:view'
        }
      },
      {
        path: 'work-order',
        name: 'WorkOrder',
        component: () => import('@/views/operation-center/WorkOrder'),
        meta: {
          title: '工单管理',
          icon: 'el-icon-document',
          permission: 'operation-center:work-order:view'
        }
      },
      {
        path: 'work-order-type',
        name: 'WorkOrderType',
        component: () => import('@/views/operation-center/WorkOrderType'),
        meta: {
          title: '工单类型',
          icon: 'el-icon-set-up',
          hidden: true,
          permission: 'operation-center:work-order:view'
        }
      },
      {
        path: 'inspection-record-detail/:id',
        name: 'InspectionRecordDetail',
        component: () => import('../views/operation-center/InspectionRecordDetail.vue'),
        meta: {
          title: '巡检记录详情',
          breadcrumb: true,
          hidden: true,
          permission: 'operation-center:daily-inspection:view'
        }
      },
      {
        path: 'inspection-task-detail/:taskId',
        name: 'InspectionTaskDetail',
        component: () => import('../views/operation-center/InspectionTaskDetail.vue'),
        meta: {
          title: '巡检任务详情',
          breadcrumb: true,
          hidden: true,
          permission: 'operation-center:daily-inspection:view'
        }
      },
      {
        path: 'maintenance-records',
        name: 'MaintenanceRecords',
        component: () => import('../views/operation-center/MaintenanceRecords.vue'),
        meta: {
          title: '机电设备台账',
          icon: 'el-icon-notebook-2',
          permission: 'operation-center:maintenance-records:view'
        }
      },
      {
        path: 'vehicle-maintenance',
        name: 'VehicleMaintenance',
        component: () => import('../views/operation-center/VehicleMaintenance.vue'),
        meta: {
          title: '车辆维保记录',
          icon: 'el-icon-van',
          permission: 'operation-center:vehicle-maintenance:view'
        }
      },
      {
        path: 'curve-analysis',
        name: 'CurveAnalysis',
        component: () => import('../views/operation-center/CurveAnalysis.vue'),
        meta: {
          title: '曲线图分析',
          icon: 'el-icon-data-line',
          permission: 'operation-center:curve-analysis:view'
        }
      },
      {
        path: 'chemical-ledger',
        name: 'ChemicalLedger',
        component: () => import('../views/operation-center/ChemicalLedger.vue'),
        meta: {
          title: '药剂台账',
          icon: 'el-icon-box',
          permission: 'operation-center:chemical-ledger:view'
        }
      },
      {
        path: 'ai-assistant',
        name: 'AiAssistant',
        component: () => import('../views/operation-center/AiAssistant.vue'),
        meta: {
          title: 'AI助手',
          icon: 'el-icon-chat-dot-round',
          permission: 'operation-center:ai-assistant:view'
        }
      },
    ]
  },
  
  // 管理中心
  {
    path: '/management-center',
    name: 'ManagementCenter',
    component: KeepAliveView,
    meta: {
      title: '管理中心',
      icon: 'el-icon-s-management',
      permission: 'management-center:view',
      requiresAuth: true
    },
    children: [
      {
        path: 'site-management-page',
        name: 'SiteManagementPage',
        component: () => import('../views/management-center/SiteManagementPage.vue'),
        meta: {
          title: '站点管理',
          icon: 'el-icon-office-building',
          permission: 'management-center:site-management-page:view'
        }
      },
      {
        path: 'site-management',
        name: 'SiteManagement',
        component: () => import('../views/management-center/SiteManagement.vue'),
        meta: {
          title: '设备管理',
          icon: 'el-icon-s-grid',
          permission: 'management-center:site-management:view'
        }
      },
      {
        path: 'gateway-management',
        name: 'GatewayManagement',
        component: () => import('../views/management-center/GatewayManagement.vue'),
        meta: {
          title: '网关管理',
          icon: 'el-icon-connection',
          permission: 'management-center:gateway-management:view'
        }
      },
      {
        path: 'camera-management',
        name: 'CameraManagement',
        component: () => import('../views/management-center/CameraManagement.vue'),
        meta: {
          title: '摄像头管理',
          icon: 'el-icon-video-camera',
          permission: 'management-center:camera-management:view'
        }
      },
      {
        path: 'industrial-camera-management',
        name: 'IndustrialCameraManagement',
        component: () => import('../views/management-center/IndustrialCameraManagement.vue'),
        meta: {
          title: '工业相机管理',
          icon: 'el-icon-camera-solid',
          permission: 'management-center:industrial-camera-management:view'
        }
      },
      {
        path: 'vehicle-management',
        name: 'VehicleManagement',
        component: () => import('../views/management-center/VehicleManagement.vue'),
        meta: {
          title: '车辆管理',
          icon: 'el-icon-truck',
          permission: 'management-center:vehicle-management:view'
        }
      },
      {
        path: 'cloud-platform',
        name: 'CloudPlatform',
        component: KeepAliveView,
        meta: {
          title: '采集云平台',
          icon: 'el-icon-cloud',
          permission: 'management-center:cloud-platform:view',
          hidden: true
        },
        children: [
          {
              path: 'cloud-configuration',
              name: 'CloudConfiguration',
              component: KeepAliveView,
              meta: {
                title: '云组态',
                icon: 'el-icon-s-platform',
                permission: 'management-center:cloud-configuration:view'
              },
              children: [
                {
                  path: 'published',
                  name: 'PublishedConfigurations',
                  component: () => import('../views/cloud-configuration/published.vue'),
                  meta: {
                    title: '已发布组态',
                    icon: 'el-icon-s-flag',
                    permission: 'management-center:cloud-configuration:published:view'
                  }
                },
                {
                  path: 'draft',
                  name: 'DraftConfigurations',
                  component: () => import('../views/cloud-configuration/draft.vue'),
                  meta: {
                    title: '待发布组态',
                    icon: 'el-icon-edit-outline',
                    permission: 'management-center:cloud-configuration:draft:view'
                  }
                },
                {
                  path: 'my-materials',
                  name: 'MyMaterials',
                  component: () => import('../views/cloud-configuration/my-materials.vue'),
                  meta: {
                    title: '我的素材库',
                    icon: 'el-icon-collection-tag',
                    permission: 'management-center:cloud-configuration:my-materials:view'
                  }
                },
                {
                  path: 'public-materials',
                  name: 'PublicMaterials',
                  component: () => import('../views/cloud-configuration/public-materials.vue'),
                  meta: {
                    title: '公共素材库',
                    icon: 'el-icon-collection',
                    permission: 'management-center:cloud-configuration:public-materials:view'
                  }
                },
                // {
                //   path: 'designer/:id?',
                //   name: 'ConfigurationDesigner',
                //   component: () => import('../views/cloud-configuration/designer.vue'),
                //   meta: {
                //     title: '3D模型设计器',
                //     permission: 'management-center:cloud-configuration:designer:view',
                //     hidden: true
                //   }
                // },
                {
                  path: 'designer/:id?',
                  name: 'ConfigurationDesigner',
                  component: () => import('../views/cloud-configuration/designer2.vue'),
                  meta: {
                    title: '工艺流程图设计器',
                    permission: 'management-center:cloud-configuration:designer:view',
                    hidden: true
                  }
                },
                {
                  path: 'preview/:id',
                  name: 'ConfigurationPreview',
                  component: () => import('../views/cloud-configuration/preview.vue'),
                  meta: {
                    title: '组态预览',
                    permission: 'management-center:cloud-configuration:preview:view',
                    hidden: true
                  }
                }
              ]
            }
        ]
      }
    ]
  },
  
  // 报表中心
  {
    path: '/report-center',
    name: 'ReportCenter',
    component: KeepAliveView,
    meta: {
      title: '报表中心',
      icon: 'el-icon-document',
      permission: 'report-center:view',
      requiresAuth: true
    },
    children: [
      {
        path: 'water-quality-data',
        name: 'WaterQualityData',
        component: () => import('../views/report-center/WaterQualityData.vue'),
        meta: { title: '水质数据', icon: 'el-icon-s-data', permission: 'report-center:water-quality-data:view' }
      },
      {
        path: 'power-data',
        name: 'PowerData',
        component: () => import('../views/report-center/PowerData.vue'),
        meta: { title: '电耗数据', icon: 'el-icon-lightning', permission: 'report-center:power-data:view' }
      },
      {
        path: 'chemical-data',
        name: 'ChemicalData',
        component: () => import('../views/report-center/ChemicalData.vue'),
        meta: { title: '药耗数据', icon: 'el-icon-s-order', permission: 'report-center:chemical-data:view' }
      },
      {
        path: 'flow-data',
        name: 'FlowData',
        component: () => import('../views/report-center/FlowData.vue'),
        meta: { title: '流量数据', icon: 'el-icon-data-line', permission: 'report-center:flow-data:view' }
      }
    ]
  },
  
  // 警情中心
  {
    path: '/police-center',
    name: 'PoliceCenter',
    component: KeepAliveView,
    meta: {
      title: '警情中心',
      icon: 'el-icon-warning-outline',
      permission: 'police-center:view',
      requiresAuth: true
    },
    children: [
      {
        path: 'real-time-police',
        name: 'RealTimePolice',
        component: () => import('../views/alarm-center/IntelligentAlarm.vue'),
        meta: {
          title: '实时告警',
          icon: 'el-icon-bell',
          permission: 'police-center:real-time-police:view'
        }
      },
      {
        path: 'history-police',
        name: 'HistoryPolice',
        component: () => import('../views/alarm-center/HistoryAlarm.vue'),
        meta: {
          title: '历史告警',
          icon: 'el-icon-time',
          permission: 'police-center:history-police:view'
        }
      },
      {
        path: 'police-config',
        name: 'PoliceConfig',
        component: () => import('../views/alarm-center/AlarmConfig.vue'),
        meta: {
          title: '告警规则配置',
          icon: 'el-icon-setting',
          permission: 'police-center:police-config:view'
        }
      },
      {
        path: 'work-order',
        name: 'WorkOrder',
        component: () => import('../views/alarm-center/WorkOrderList.vue'),
        meta: {
          title: '工单管理',
          icon: 'el-icon-document',
          permission: 'police-center:work-order:view',
          hidden: true
        }
      }
    ]
  },
  
  // 系统管理
  {
    path: '/system-management',
    name: 'SystemManagement',
    component: KeepAliveView,
    meta: {
      title: '系统管理',
      icon: 'el-icon-s-tools',
      permission: 'system-management:view',
      requiresAuth: true
    },
    children: [
      {
        path: 'dashboard-layout-list',
        name: 'DashboardLayoutList',
        component: () => import('../views/management-center/DashboardLayoutList.vue'),
        meta: {
          title: '大屏管理',
          icon: 'el-icon-monitor',
          permission: 'system-management:dashboard-layout:view'
        }
      },
      {
        path: 'dashboard-layout-editor',
        name: 'DashboardLayoutEditor',
        component: () => import('../views/management-center/DashboardLayoutEditor.vue'),
        meta: {
          title: '首页配置编辑器',
          icon: 'el-icon-edit',
          permission: 'system-management:dashboard-layout:view',
          hidden: true
        }
      },
      {
        path: 'screen-management',
        name: 'ScreenManagement',
        component: () => import('../views/management-center/ScreenManagement.vue'),
        meta: {
          title: '大屏展示',
          icon: 'el-icon-data-screen',
          permission: 'system-management:screen-management:view',
          hidden: true
        }
      },
      {
        path: 'user-management',
        name: 'UserManagement',
        component: () => import('../views/management-center/UserManagement.vue'),
        meta: {
          title: '用户管理',
          icon: 'el-icon-user',
          permission: 'system-management:user-management:view'
        }
      },
      {
        path: 'role-management',
        name: 'RoleManagement',
        component: () => import('../views/management-center/RoleManagement.vue'),
        meta: {
          title: '角色管理',
          icon: 'el-icon-s-custom',
          permission: 'system-management:role-management:view'
        }
      },
      {
        path: 'permission-data-management',
        name: 'PermissionDataManagement',
        component: () => import('../views/management-center/PermissionDataManagement.vue'),
        meta: {
          title: '权限管理',
          icon: 'el-icon-lock',
          permission: 'system-management:permission-data-management:view'
        }
      },
      {
        path: 'operation-log',
        name: 'OperationLog',
        component: () => import('../views/management-center/OperationLog.vue'),
        meta: {
          title: '操作日志',
          icon: 'el-icon-document',
          permission: 'system-management:operation-log:view'
        }
      }
    ]
  },
  
  // 默认路由
  {
    path: '*',
    redirect: '/home'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: staticRoutes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (to.path === '/login') {
    if (token) {
      next('/home')
    } else {
      next()
    }
    return
  }
  if (!token) {
    next('/login')
    return
  }
  // Permission check
  if (to.matched.some(record => record.meta.requiresAuth !== false && record.meta.permission)) {
    const userStr = localStorage.getItem('user')
    const user = userStr ? JSON.parse(userStr) : {}
    if (user.roleId !== 1) {
      const permissions = user.permissions || []
      if (permissions.length > 0) {
        const hasPermission = to.matched.some(record => {
          if (record.meta.requiresAuth === false) return false
          if (!record.meta.permission) return false
          return permissions.includes(record.meta.permission)
        })
        if (!hasPermission) {
          next('/403')
          return
        }
      }
    }
  }
  next()
})

// 动态加载路由
let routesLoaded = false

export function loadDynamicRoutes() {
  if (routesLoaded) {
    const userStr = localStorage.getItem('user')
    const user = userStr ? JSON.parse(userStr) : {}
    let menuRoutes
    if (user.roleId === 1 || !user.permissions) {
      menuRoutes = dynamicRoutes
    } else {
      const permissions = user.permissions || []
      if (permissions.length === 0) {
        menuRoutes = dynamicRoutes
      } else {
        menuRoutes = filterRoutes(dynamicRoutes, permissions)
      }
    }
    store.dispatch('setMenuList', menuRoutes)
    return dynamicRoutes
  }

  router.addRoutes(dynamicRoutes)
  const userStr = localStorage.getItem('user')
  const user = userStr ? JSON.parse(userStr) : {}
  let menuRoutes
  if (user.roleId === 1 || !user.permissions) {
    menuRoutes = dynamicRoutes
  } else {
    const permissions = user.permissions || []
    if (permissions.length === 0) {
      menuRoutes = dynamicRoutes
    } else {
      menuRoutes = filterRoutes(dynamicRoutes, permissions)
    }
  }
  store.dispatch('setMenuList', menuRoutes)
  routesLoaded = true
  return dynamicRoutes
}

// 过滤路由
function filterRoutes(routes, permissions) {
  if (!Array.isArray(permissions)) {
    return []
  }
  
  return routes.map(route => {
    if (!route || !route.meta) {
      return null
    }
    
    if (route.meta.hidden) {
      return null
    }
    
    let newRoute = { ...route }
    
    if (route.children) {
      const filteredChildren = filterRoutes(route.children, permissions)
      const validChildren = filteredChildren.filter(child => child !== null)
      if (validChildren.length > 0) {
        newRoute.children = validChildren
        return newRoute
      }
    }
    
    if (route.meta.permission) {
      if (!permissions.includes(route.meta.permission)) {
        return null
      }
    }
    
    return newRoute
  }).filter(route => route !== null)
}

// 生成菜单列表
export function generateMenuList() {
  const user = store.getters.user
  if (user.roleId === 1 || !user.permissions || user.permissions.length === 0) {
    return dynamicRoutes
  }
  return filterRoutes(dynamicRoutes, user.permissions)
}

export default router
export { dynamicRoutes }